import React from "react";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import VTAdminDancerEdit from "../page/VTAdminDancerEdit";

export default function LandingAdminDancerEdit({page}) {
    return (
        <>
            <Header headerType="AdminEditDancerOnly"/>
            <VTAdminDancerEdit/>
            <Footer/>
        </>
    );
}